'use client'

import { Button, Cell, Dialog, Spacer, Text } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { clickEvent } from '@marketplace-web/processing-listing/processing-listing-data'

import { SELLING_HELP_URL } from '../../constants/routes'

type Props = {
  show: boolean
  onClose: () => void
}

const ProcessingListingStatusModal = ({ show, onClose }: Props) => {
  const translate = useTranslate('processing_listing.modal')
  const { track } = useTracking()

  const handleFaqLinkClick = () => {
    track(
      clickEvent({
        target: 'processing_status_modal_faq_link',
        screen: 'processing_listing_modal',
      }),
    )
  }

  return (
    <Dialog show={show} testId="processing-listing-modal">
      <Cell>
        <Text as="h1" text={translate('title')} alignment="left" type="heading" />
        <Spacer size="large" />
        <Text
          as="span"
          text={translate('body', {
            'catalog-rules-link': chunks => (
              <a
                onClick={handleFaqLinkClick}
                href={SELLING_HELP_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {chunks}
              </a>
            ),
          })}
          html
        />
        <Spacer size="large" />
        <Button
          text={translate('actions.close')}
          onClick={onClose}
          styling="filled"
          testId="processing-listing-modal-close-button"
        />
      </Cell>
    </Dialog>
  )
}

export default ProcessingListingStatusModal
